// extracted by mini-css-extract-plugin
module.exports = {"Solution":"SulotionColumn_Solution__2K5wC"};